import EventBase from './EventBase'
import EventID from './EventID'
import EventFilter from './EventFilter'

export default class EventDressRole extends EventBase {
    /*
     * 显示角色事件构造函数
     */
    constructor() {
        super()
        this.Parameter = [
            '0',
            '0',
            '0',
            '0',
            '0',
            '0',
            '100',
            '100',
            '255',
            '0',
            '',
            '',
            '',
            '',
            '',
            '',
        ]
    }

    /*
     * 事件ID
     */
    public Code = EventID.DressRole

    // #region 事件内关键属性参数
    get PicID() {
        return parseInt(this.Parameter[0])
    }
    set PicID(val) {
        this.Parameter[0] = val.toString()
    }
    /*
     * 图片名称是否为橙光字符串指定
     * 0为是非字符串指定（固定图片），1为是橙光动态字符串指定
     */
    get IsUserStrAssigned() {
        return this.Parameter[1] == '1'
    }
    set IsUserStrAssigned(val) {
        this.Parameter[1] = val ? '1' : '0'
    }

    /*
     * 初始立绘信息（参数2为1时，此字段为字符串索引；为0时，角色ID）
     */
    get HalfInfo() {
        return parseInt(this.Parameter[2])
    }
    set HalfInfo(val) {
        this.Parameter[2] = val.toString()
    }

    /*
     * 图片坐标是否为橙光数值指定
     * 0为非数值指定（常量），1为是橙光动态数值指定
     */
    get IsAssigned() {
        return this.Parameter[3] == '1'
    }
    set IsAssigned(val) {
        this.Parameter[3] = val ? '1' : '0'
    }
    /*
     * X坐标
     */
    get X() {
        try {
            return parseInt(this.Parameter[4])
        } catch {
            return 0
        }
    }
    set X(val) {
        this.Parameter[4] = val.toString()
    }
    /*
     * Y坐标
     */
    get Y() {
        try {
            return parseInt(this.Parameter[5])
        } catch {
            return 0
        }
    }
    set Y(val) {
        this.Parameter[5] = val.toString()
    }
    /*
     * X轴缩放率
     */
    get ZoomX() {
        return parseInt(this.Parameter[6])
    }
    set ZoomX(val) {
        this.Parameter[6] = val.toString()
    }
    /*
     * Y轴缩放率
     */
    get ZoomY() {
        return parseInt(this.Parameter[7])
    }
    set ZoomY(val) {
        this.Parameter[7] = val.toString()
    }
    /*
     * 图片透明度，0~255
     */
    get Opacity() {
        return parseInt(this.Parameter[8])
    }
    set Opacity(val) {
        this.Parameter[8] = val.toString()
    }
    /*
     * 是否使用了镜像功能
     * 0否1是
     */
    get IsMirror() {
        return this.Parameter[9] == '1'
    }
    set IsMirror(val) {
        this.Parameter[9] = val ? '1' : '0'
    }
    /*
     * 描述信息
     */
    get Description() {
        if (this.Parameter[10]) {
            return this.Parameter[10]
        }
        return `编号${this.PicID}，${(this.IsUserStrAssigned ? '字符串：' : '角色') + (this.HalfInfo + 1)}，x ${this.X}，y ${this.Y}，透明${this.Opacity}，${this.ZoomX}% ${this.ZoomY}%`
    }
    set Description(val) {
        this.Parameter[10] = val
    }

    /*
     * 滤镜
     */
    get Filter() {
        return new EventFilter(this.Parameter, 12)
    }
    set Filter(val) {
        this.Parameter = val.ToParameter(this.Parameter, 12)
    }
    // #endregion

    /*
     * 获取该事件在事件列表的描述信息
     */
}
